import { actions as chatTicketActions } from 'react/api/actions/chatTicketActions';
import { fromJS } from 'immutable';

const initialState = fromJS({
  activeTicket: {},
  ticketResolutions: [],
  modalFinishCallIsOpen: false,
  modalReassignCallIsOpen: false
});

export default (state = initialState, action) => {
  switch (action.type) {
    case chatTicketActions.toggleFinishCallModal: {
      const { payload } = action;

      return state
        .updateIn(['modalFinishCallIsOpen'], (isOpen) => !isOpen)
        .setIn(['activeTicket'], fromJS(payload));
    }
    case chatTicketActions.toggleReassignCallModal: {
      const { payload } = action;

      return state
        .updateIn(['modalReassignCallIsOpen'], (isOpen) => !isOpen)
        .setIn(['activeTicket'], fromJS(payload));
    }
    case chatTicketActions.updateTicketResolutions: {
      const { payload } = action;

      return state.setIn(['ticketResolutions'], fromJS(payload));
    }
    case chatTicketActions.updateActiveTicket: {
      const { payload } = action;

      return state.mergeIn(['activeTicket'], payload);
    }
    default:
      return state;
  }
};
